import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'

Vue.use(VueI18n)

export const FALLBACK_LOCALE = 'en'
const STORAGE_KEY = 'locale'

const context = require.context('@/locales', true, /\.json$/)

const messages = {}
const meta = {}

context.keys().forEach(key => {
  const match = key.match(/^\.\/([^/]+)\/([^/]+)\.json$/)
  if (!match) return
  const [, locale, namespace] = match
  const content = context(key)
  if (namespace === '_meta') {
    meta[locale] = content
    return
  }
  if (!messages[locale]) messages[locale] = {}
  messages[locale][namespace] = content
})

export const availableLocales = Object.keys(messages)
  .map(code => ({
    code,
    name: (meta[code] && meta[code].name) || code,
    flag: (meta[code] && meta[code].flag) || '',
  }))
  .sort((a, b) => a.name.localeCompare(b.name))

function detectLocale() {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored && messages[stored]) return stored
  const browser = (navigator.language || '').slice(0, 2).toLowerCase()
  if (messages[browser]) return browser
  return FALLBACK_LOCALE
}

const i18n = new VueI18n({
  locale: detectLocale(),
  fallbackLocale: FALLBACK_LOCALE,
  silentFallbackWarn: true,
  messages,
})

export function setLocale(code, { persistToServer = true } = {}) {
  if (!messages[code]) return false
  i18n.locale = code
  localStorage.setItem(STORAGE_KEY, code)
  document.documentElement.setAttribute('lang', code)
  //keep vuetify's own component strings in step. required lazily: vuetify imports this module
  try {
    const vuetify = require('@/plugins/vuetify').default
    if (vuetify && vuetify.framework && vuetify.framework.lang && vuetify.framework.lang.locales[code]) {
      vuetify.framework.lang.current = code
    }
  } catch (e) {
    //vuetify not ready yet, it reads i18n.locale on construction anyway
  }
  if (persistToServer && localStorage.getItem('freshToken')) {
    axios.put('/update-language', { language: code }).catch(() => {})
  }
  return true
}

document.documentElement.setAttribute('lang', i18n.locale)

export default i18n
